import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import { ProfileContext } from "../../context/ProfileContext";
import { dateFormatter } from "../../utils/helper";

function ReferralManagement() {
    const { referralData } = useContext(ProfileContext);
    const referral = referralData?.data

  return (
    <div className="container-fluid">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-9 main-dash-left">
          <section className="back-dashboard-sec comn-dashboard-page">
            <div className="notifi-list d-flex">
              <div>
                <h6 className="comm_page_heading">Referral Management</h6>
                <p className="comm_page_sub_heading">
                  Receive AI-driven diagnostic suggestions based on consultation
                  data, helping guide accurate and timely treatment decisions
                </p>
              </div>
            </div>
            <div className="comm-table pt-0 refferal_table_outer">
              <Table>
                <thead>
                  <tr className="head-class-td">
                    <th>Sr. no.</th>
                    <th>Patient ID</th>
                    <th>Patient’s Name</th>
                    <th>Department</th>
                    <th>Appointment Date</th>
                    <th>Tracking/Status</th>
                    <th width="10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {referral && referral.length > 0 ?
                    referral.map((data, index) => {
                      return (
                        <tr key={data._id}>
                          <td>{index + 1}.</td>
                          <td className="id_txt">#{data?.userData?.patient_id}</td>
                          <td>{data?.userData?.full_name}</td>
                          <td>{data?.diagnostic_data?.referral}</td>
                          <td>{dateFormatter(data?.diagnostic_data?.timestamp)} </td>
                          <td>
                            <div className={`dropdown_inner_list_select refer_table_dropdown 
                            ${data?.diagnostic_data?.tracking_status === 'Completed' ? 'completed' : data?.diagnostic_data?.tracking_status === 'In Progress' ? 'scheduled' : 'pending'}`}>
                              <p>{data?.diagnostic_data?.tracking_status || "Pending"}</p>
                              {/* <Form.Select value={data?.diagnostic_data?.tracking_status || "Pending"}
                              // onChange={(e) => handleStatusChange(e, data._id)}
                              >
                                <option value="Pending">Pending</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Completed">Completed</option>
                              </Form.Select> */}
                            </div>
                          </td>
                          <td>
                            <Link className="table-view-btn" to="/referral-management-view" state={{ referral: data }}>
                              <RiEyeLine />
                            </Link>
                          </td>
                        </tr>
                      )
                    })
                    :
                    null
                  }
                </tbody>
              </Table>
            </div>
            {/* <div className="d-flex table_bottom_row">
              <h4 className="page_count_txt">1-8 of 50 items</h4>
              <div className="d-flex btn_grp">
                <button className="table_bott_btn">Previous</button>
                <button className="table_bott_btn">Next</button>
              </div>
            </div> */}
          </section>
        </div>
      </div>
    </div>
  );
}

export default ReferralManagement;
